/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';

import { getCurrentOverviewDetails, getCurrentSelectedVisit } from '../../../selectors';

const useOverviewTab = () => {
  const overviewInfo = useSelector(getCurrentOverviewDetails);
  const { agency, partner } = useSelector(getCurrentSelectedVisit);

  return {
    overviewInfo,
    agency,
    partner,
  };
};

export default useOverviewTab;
